export default __webpack_public_path__ + "static/media/layers-master.8ee7d110.svg";